import { fetchMyRequestsList } from '../../../services/accreditation-service/accreditation-service';
import DataTable from '../../../components/DataTable/DataTable';
import { ACCR_REQUEST_COLUMNS } from './columns-definition';
import PageTitle from '../../../components/PageTitle';
import { getTranslation } from '../../../utils/functions';
import { Card, Link } from '@hid-galaxy-ui/galaxy-react';
import { PageSize } from '../../../constants/common';
import { IAppProps } from '../../../App';
import useFetchTableData from '../../../hooks/useFetchTableData';
import { ITableColumnConfig } from '../../../components/DataTable/IDataTable';
import { getAccrRequestStatusTranslationKey } from '../../../utils/status';
import ProfileIcon from '../../../components/ProfileIcon/profileIcon';
import { PATHS_WITH_PARAMS } from '../../../utils/paths';

const MyRequests = (props: IAppProps) => {
  const { toasts, setToasts } = props;

  const {
    data,
    isLoading,
    currentPage,
    fetchData,
    handlePageNumberClick,
    handlePageSizeChange,
  } = useFetchTableData({
    apiFunction: fetchMyRequestsList,
    initialParams: { pageNo: 0, pageSize: PageSize },
    toasts,
    setToasts,
  });

  const getColumns = () => {
    return ACCR_REQUEST_COLUMNS.map((column) => {
      return {
        ...column,
        headerLabel: getTranslation(column.headerLabel),
      };
    });
  };

  const renderTitle = () => {
    return <PageTitle>{getTranslation('MY_REQUESTS')}</PageTitle>;
  };

  const extendStatusColumnConfig = (
    _column: ITableColumnConfig,
    rowData: any,
    _rowIndex: number,
    _columnIndex: number,
  ): any => {
    return getTranslation(getAccrRequestStatusTranslationKey(rowData?.status));
  };

  const extendEventColumnConfig = (
    _column: ITableColumnConfig,
    rowData: any,
    _rowIndex: number,
    _columnIndex: number,
  ): any => {
    return rowData?.eventNames?.join(', ');
  };

  const extendRequestIdColumnConfig = (
    _column: ITableColumnConfig,
    rowData: any,
    _rowIndex: number,
    _columnIndex: number,
  ): any => {
    return (
      <Link
        target="_self"
        link={`${PATHS_WITH_PARAMS.request_details.replace(':requestId', rowData.requestId)}`}
      >
        {rowData.requestId}
      </Link>
    );
  };

  const extendDataColumnConfig = (
    _column: ITableColumnConfig,
    rowData: any,
    _rowIndex: number,
    _columnIndex: number,
  ): any => {
    return rowData.photos?.length ? (
      <div>
        <span>{rowData.dataCompletedPercentage}&#37;</span>
        <span className="hid-spacing__ml-03">
          <ProfileIcon />
        </span>
      </div>
    ) : (
      <span>{rowData.dataCompletedPercentage}&#37;</span>
    );
  };

  const ACCREDITATION_REQUESTS_CUSTOM_COLUMNS_CONFIG = {
    renderDataCompletedPercentage: extendDataColumnConfig,
    renderStatus: extendStatusColumnConfig,
    renderRequestId: extendRequestIdColumnConfig,
    renderEventNames: extendEventColumnConfig,
  };

  return (
    <Card title={renderTitle()}>
      {
        <DataTable
          isPageLoading={isLoading}
          columnsConfig={getColumns()}
          data={data?.items || []}
          shouldRenderPagination={true}
          currentPage={currentPage}
          handlePageNumberClick={handlePageNumberClick}
          paginationData={data}
          onPageSizesClick={handlePageSizeChange}
          dependencies={ACCREDITATION_REQUESTS_CUSTOM_COLUMNS_CONFIG}
          dataKey="requestId"
        />
      }
    </Card>
  );
};

export default MyRequests;
